export default "__VITE_ASSET__c25b8726__"